module.exports = __webpack_public_path__ + "img/CompScope_Space_02.fbf590e0.png";